import * as React from 'react';
import FAB from '../../../components/core/FAB';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBook,
  faBookmark,
  faBrain,
  faGraduationCap,
} from '@fortawesome/free-solid-svg-icons';
import { ColorPalette } from '../../../constant';
import { memo, useContext, useEffect } from 'react';
import { navigate } from 'gatsby';

import { useLiveQuery } from 'dexie-react-hooks';
import {
  DexieContext,
  FlashcardModes,
  USER,
} from '../../../components/core/PageWrapper';

const FlashcardsMenu: React.FC = () => {
  const db = useContext(DexieContext);
  const config = useLiveQuery(
    async () => await db.table('config').where('id').equals(USER).first()
  );

  const actions = [
    {
      label: 'Study',
      icon: <FontAwesomeIcon icon={faBrain} color="black" />,
      onClick: () => handleConfigChange(FlashcardModes.Study),
    },
    {
      label: 'Exam',
      icon: <FontAwesomeIcon icon={faGraduationCap} color="black" />,
      onClick: () => handleConfigChange(FlashcardModes.Exam),
    },
    {
      label: 'Review',
      icon: <FontAwesomeIcon icon={faBookmark} color="black" />,
      onClick: () => handleConfigChange(FlashcardModes.Review),
    },
  ];

  function handleConfigChange(mode: FlashcardModes) {
    db.table('config').update(USER, {
      flashcardsModes: mode,
    });
  }

  function getModeIcon(mode: FlashcardModes) {
    switch (mode) {
      case FlashcardModes.Study:
        return faBrain;
      case FlashcardModes.Exam:
        return faGraduationCap;
      case FlashcardModes.Review:
        return faBookmark;
      default:
        return faBook;
    }
  }

  useEffect(() => {
    if (config?.flashcardsModes) {
      navigate(`/flashcards/${config?.flashcardsModes}`);
    }
  }, [config?.flashcardsModes]);

  return (
    <FAB
      actions={actions}
      left
      textColor={ColorPalette.WHITE}
      backgroundColor={ColorPalette.DARKER_BLUE}
      icon={getModeIcon(config?.flashcardsModes)}
    />
  );
};

export default memo(FlashcardsMenu);
